<div class="content plan-result">
  <div class="container-fluid">
    <div class="page-title clearfix">
      <h1 class="float-left">
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> {{resultDetailInfo.name}} {{'Last Run Result' | translate}}
      </h1>
    </div>
    <section>
      <div class="page-filter clearfix two-filter">
        <div class="filter-flex">
          <div class="filter">
            <div class="filter-list">
              <button type="button" class="btn btn-outline-dark btn-sm" (click)="prveTestPlan()" [disabled]="currentIndex === result_list.length - 1"> <span class="pi pi-chevron-left"></span></button>
              <span style="margin: 0 15px; font-weight: bold;">{{ resultDetailInfo ? resultDetailInfo.lastRuntime : '' }}</span>
              <button type="button" class="btn btn-outline-dark btn-sm" (click)="nextTestPlan()" [disabled]="currentIndex === 0"> <span class="pi pi-chevron-right"></span></button>
            </div>
          </div>
          <div class="filter search float-right">
            <div class="button">
              <input type="text" pInputText placeholder="{{'Search' | translate}}" (input)="dt.filterGlobal($event.target.value, 'contains')" class="pInputText">
            </div>
          </div>
        </div>
      </div>
      <div _ngcontent-wpc-c26="" class="statusString">
        <div class="statusList Normal"><span class="statusLabel">{{'Passed' | translate}} </span> <span class="statusLength">{{ passCnt ? passCnt : 0 }}</span> </div>
        <div class="statusList Critical"><span class="statusLabel">{{'Failed' | translate}}</span> <span class="statusLength">{{ failCnt ? failCnt : 0 }}</span> </div>
      </div>
      <div class="content-info evnets">
        <p-table #dt class="deviceTable pageAllOptions" [columns]="resultDetail_columns_cols" [value]="resultDetail" [rows]="10" [paginator]="true"
          [rowsPerPageOptions]="[10,20,{showAll:'All'}]" [scrollable]="true">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns; let i= index" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header | translate}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
              <td style="width: 200px" class="col-nowrap">{{rowData.deviceName}}</td>
              <td style="width: 200px" class="col-nowrap">{{rowData.model}}</td>
              <td style="width: 150px" class="col-nowrap">
                <ng-container [ngSwitch]="rowData.status">
                  <span *ngSwitchCase="0" class="status-passed normal">{{'Passed' | translate}}</span>
                  <span *ngSwitchCase="2" class="status-failed critical">{{'Failed' | translate}}</span>
                  <span *ngSwitchCase="3" class="status-none">{{'Not Executed' | translate}}
                    <small><i class="fa fa-info-circle" aria-hidden="true" pTooltip="{{'Not Executed: Battery test process timed out or device has no license.' | translate}}" tooltipPosition="bottom"
                        tooltipStyleClass="tooltips_gary"></i>
                    </small>
                  </span>
                </ng-container>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <div translate class="ui-emptymessage">No Data found</div>
          </ng-template>
        </p-table>
      </div>
      <div class="note">
        <strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{'Note' | translate}}: </strong>
        {{'3-Phase UPS and Gateway-connected devices do not support battery tests and are excluded from these results.' | translate}}
      </div>
    </section>
  </div>
</div>